import { render } from "./Kontakt.vue?vue&type=template&id=8dee12a0"
import script from "./Kontakt.vue?vue&type=script&lang=js"
export * from "./Kontakt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\96keh\\Desktop\\dev\\liof\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__